const initialState = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
  page: 0,
  limit: 10,
  totalRedeemed: 0,
  referralData:[],
  referralTotal:0,
  referralPage: 0,
  referralLimit: 10,
  referralConversion:0

};

export default initialState;
